import {getPkgGroupList, getSupplierOption, getPkgTypeOption, getPkgStateOption, getAgentPkgGroupList, getPkgOfGroup,getHaoka,getSupplierLimitOption} from '@/api/package.js'
import {getAgentListOption,getAgentListOption1,getAgentListOptions} from '@/api/customers.js'
import {getBranchSupplierList} from '@/api/system.js'
import request from '@/utils/request.js'
import qs from 'qs';


var common = {
	sysRequest(url, data, method){
	    let obj = {};
		if(method.toLowerCase()=="get"){
			obj = {
				url: url,
				method: method,
				params: data,
			}
		}else if(method.toLowerCase()=="post"){
			obj = {
				url,
				method,
				data,
			}
		}
		return request(obj)
	},
    optionCallback(res, _this, optionsKey){
        if(res.data.code == 200){
            _this.$data[optionsKey] = res.data.data;
        }
    },
    /****获取所有套餐组****/
    getPkgGroupListCom(_this, optionsKey){
        getPkgGroupList({}).then(res => {
            this.optionCallback(res, _this, optionsKey)
        })
    },
    /****获取供应商****/
    getSupplierOptionCom(_this, optionsKey){
        getSupplierOption().then(res => {
            this.optionCallback(res, _this, optionsKey)           
        })        
    },
    getSupplierLimitOptionCom(_this, optionsKey){
        getSupplierLimitOption().then(res => {
            this.optionCallback(res, _this, optionsKey)           
        })        
    },

    gethaokaList(_this, optionsKey){
        getHaoka().then(res => {
            this.optionCallback(res, _this, optionsKey)           
        })        
    },
    /****获取供应商（各地市）****/
    getBranchSupplierOptionCom(_this, optionsKey){
        getBranchSupplierList({}).then(res => {
            this.optionCallback(res, _this, optionsKey)           
        })        
    },  
    /****获取套餐类型****/ 
    getPkgTypeOptionCom(_this, optionsKey){
        getPkgTypeOption().then(res => {
            this.optionCallback(res, _this, optionsKey)           
        });        
    },
    /****获取套餐状态****/
    getPkgStateOptionCom(_this, optionsKey){
        getPkgStateOption().then(res => {
            this.optionCallback(res, _this, optionsKey)         
        });        
    },
    /****获取代理商****/
    getAgentListOptionCom(_this, optionsKey){
        getAgentListOption({}).then(res => {
            this.optionCallback(res, _this, optionsKey)
        });        
    },
      /****获取所有业务员****/
      getAgentListOptionComs(_this, optionsKey){
        getAgentListOptions({}).then(res => {
            this.optionCallback(res, _this, optionsKey)
        });        
    },
        /****获取代理商****/
        getAgentListOptionCom1(_this, optionsKey){
            getAgentListOption1({}).then(res => {
                this.optionCallback(res, _this, optionsKey)
            });        
        },
    /****获取代理商的套餐组****/
    getAgentPkgGroupListCom(_this, optionsKey){
        getAgentPkgGroupList({}).then(res => {
            this.optionCallback(res, _this, optionsKey)
        });        
    },
    /****获取某一个套餐组下的所有套餐****/
        getPkgOfGroupCom(_this, optionsKey, data){
            getPkgOfGroup(data).then(res => {
                this.optionCallback(res, _this, optionsKey)
            });
        },
    /*
    * 重置翻页组件的当前页为第1页
    */
    resetCurrentPage(_this, $event, tbpgKey){
        if($event){        
            _this.$data[tbpgKey].currentPage = 1;
            var initData = _this.$options.data();            
            _this.$data[tbpgKey].pageSize = initData[tbpgKey].pageSize;
        }
    },
    /*
    * 组合搜索参数与分页参数
    */    
    getRequestParams(_this, tbpgKey, searchParams){
        var pgParams = {
            perPageNum: _this.$data[tbpgKey].pageSize,
            pageNo: _this.$data[tbpgKey].currentPage
        }
    
        var params = JSON.parse(JSON.stringify(searchParams));
        deleteSpaceKey(params);
        var params = Object.assign({}, pgParams, params);
        return params;
    
        function deleteSpaceKey(json){
            for(var key in json){
                if(json[key] === '' || json[key] === null){
                    delete json[key];
                }
                if(json.time){
                    json.startTimeString = json.time[0] + ' 00:00:00';
                    json.endTimeString = json.time[1] + ' 23:59:59';
                    delete json.time; 
                }
                if(json.timePkg){
                    json.startTimeStringPkg = json.timePkg[0] + ' 00:00:00';
                    json.endTimeStringPkg = json.timePkg[1] + ' 23:59:59';
                    delete json.timePkg; 
                }
            }
        }    
    },
    /*
    * 获取表单的回调
    */     
    listCallback(_this, respose, tablePagination){
        if(respose.data.code == 200){
            var result = respose.data.data;
            if(result){
                _this.$data[tablePagination].tableData = result.resultList;
                _this.$data[tablePagination].total = result.totalNum;
                _this.$data[tablePagination].currentPage = result.pageNo;
                _this.$data[tablePagination].pageSize = result.perPageNum;                
            }else{
                _this.$data[tablePagination].tableData = [];
                var initData = _this.$options.data()[tablePagination];
                _this.$data[tablePagination].total = initData.total;
                _this.$data[tablePagination].currentPage = initData.currentPage;
                _this.$data[tablePagination].pageSize = initData.pageSize;
            }

        }else{
            _this.$message.error(respose.data.message);
        }
    },

    showTxtByState(state, obj){
        return obj[state]
    }, 
    deleteSpaceKey(json){
        for(var key in json){
            if(json[key] === '' || json[key] === null){
                delete json[key];
            }
            if(json.time){
                json.startTimeString = json.time[0] + ' 00:00:00';
                json.endTimeString = json.time[1] + ' 23:59:59';
                delete json.time; 
            }
        }
    }
}

export default common